import { styled } from '@linaria/react';

export const CompactBetsGridWrapper = styled.div``;

export const TableHeaderWrapper = styled.div`
  background: var(--oc-bg-grey);
  padding: 5px 18px;
  display: flex;
  justify-content: flex-end;
  align-items: center;

  @media (min-width: 768px) {
    display: none;
  }
`;

export const TableHeaderText = styled.div`
  font-family: var(--oc-font-family);
  color: var(--oc-text-subtext);
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
`;

export const CompactBetsGridContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  padding: 10px 15px 0;

  @media (min-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
  }

  &.newUI {
    border: 1px solid var(--ogm-border-color-2);
    border-left: 0;
    border-right: 0;
    padding: 0;

    grid-gap: 1px;
    background: var(--ogm-border-color-2);
  }
`;

export const BetItem = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 0;
  border-bottom: 1px solid var(--oc-line-secondary);
  padding: 10px 0 12px;

  @media (min-width: 768px) {
    &:nth-child(odd) {
      padding: 10px 15px 12px 0;
    }

    &:nth-child(even) {
      padding: 10px 0 12px 15px;
    }
  }

  &.newUI {
    padding: 10px 15px;
    border-bottom: none;
    background: var(--ogm-white);

    & a {
      font-size: 16px;
      font-weight: 400;
      line-height: 24px;
    }
  }
`;

export const BetName = styled.a`
  color: var(--ogm-text-body);
  font-family: var(--oc-font-family);
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 19px;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }

  &.disabled {
    cursor: none;
    pointer-events: none;
    opacity: 0.5;

    &:hover {
      text-decoration: none;
    }
  }
`;

export const OddButtonContainer = styled.div``;

export const BetsShowMore = styled.div`
  font-family: var(--oc-font-family);
  color: var(--oc-primary-blue);
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 19px;
  padding: 15px 0 15px;
  text-align: center;
  text-decoration: none;
  position: relative;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
`;
